import React from 'react';

import FormControl from '@material-ui/core/FormControl';
import FormHelperText from '@material-ui/core/FormHelperText';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';

class StandardInput extends React.Component {

  render() {

    const {
      pattern = "",
      disabled = false,
      error = null,
      focus = false,
      value = undefined,
      id = null,
      attribute,
      label,
      inputType = null,
      password = false,
      startAdornment = null,
      endAdornment = null,
      onChange = function () {},
      onKeyUp = function () {},
      style = {},
    } = this.props;

    return (
      <FormControl style={ style } error={error !== null}>
        <InputLabel htmlFor={attribute}>{label}</InputLabel>
        <Input
          color="primary"
          id={id || attribute}
          pattern={pattern}
          disabled={disabled}
          value={value}
          type={!!inputType ? inputType : (!password ? 'input' : 'password')}
          autoFocus={focus}
          startAdornment={startAdornment}
          endAdornment={endAdornment}
          onChange={onChange}
          onKeyUp={onKeyUp}
        />
        {
          error !== null ?
          <FormHelperText id={`${attribute}-error`}>{error}</FormHelperText>
          : null
        }
      </FormControl>
    );
  }
}

export default (StandardInput);
